export default __webpack_public_path__ + "img/wp.752d1b35.svg";